import { Helmet } from 'react-helmet-async'

import { faCog } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, Columns, SaveFormModule,
} from '@domain-group/suit-theme'

import useAgency, { useAgencyForm } from '@hooks/useAgency'
import useAgencySelector from '@hooks/useAgencySelector'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'
import PageHeader from '@components/PageHeader'

import handleCallbackAction from '@functions/handleCallbackAction'

import ArtworkSettings from '../ArtworkSettings'
import EmailSettings from '../EmailSettings'
import QuoteSettings from '../Quotes'

const PageContent = () => {
  const { selectedAgency } = useAgencySelector()

  const formPayload = useAgencyForm(selectedAgency)
  const { entityState } = formPayload

  const {
    callbacks: {
      updateAgency: updateFn,
    },
    updating,
  } = useAgency(selectedAgency)

  const updateAgencyPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: entityState,
    toastText: 'Agency Settings Updated',
  }

  return (
    <>
      <Helmet>
        <title>Settings | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="settings"
        nestedNavigation
        tabBarItems={[
          {
            href: '#',
            icon: faCog,
            key: 'settings',
            title: 'Settings',
          },
        ]}
        title="Settings"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <NotificationBannerLocation locationKey="agency.agencyManager.settings.banner" />

            <ArtworkSettings formPayload={formPayload} />

            <EmailSettings formPayload={formPayload} />

            <QuoteSettings formPayload={formPayload} />

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                loading={updating}
                // @ts-expect-error TS2322
                marginLeft="auto"
                // @ts-expect-error TS2345
                onClick={() => handleCallbackAction(updateAgencyPayload)}
                size="medium"
              >
                Save Settings
              </Button>
            </SaveFormModule>
          </Columns.Main>

          <Columns.Sidebar>
            <NotificationModuleLocation locationKey="agency.agencyManager.settings.sidebar" />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
